import InfoBar from './InfoBar.vue';
export default InfoBar;
